import { LadzoConsole as Lc } from "../js/global/ladzo-console.js";
import { createApp } from "vue";
import App from "./testMapa.vue";
export function zobrazMapu() {
  Lc.f("zobrazMapu test");
  createApp(App).mount("#dvAppTest");
}
